import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = { class: "rich-textarea" };
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_QuillEditor = _resolveComponent("QuillEditor");
    return (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createVNode(_component_QuillEditor, {
            ref: "quillEditor",
            content: _ctx.content,
            "onUpdate:content": _cache[0] || (_cache[0] = ($event) => ((_ctx.content) = $event)),
            options: _ctx.editorOptions,
            contentType: "html",
            theme: "snow",
            onBlur: _cache[1] || (_cache[1] = ($event) => (_ctx.$emit('blur', $event))),
            onTextChange: _ctx.handleTextChange,
            onSelectionChange: _ctx.handleSelectionChange,
            class: "quill-editor"
        }, null, 8 /* PROPS */, ["content", "options", "onTextChange", "onSelectionChange"])
    ]));
}
